// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"2030536b","97":"69d003f4","119":"cf5b62cd","215":"69f6fbcd","406":"d49a9b49","444":"a350214f","453":"38aa5bda","489":"a4c736a1","549":"dca002f5","577":"51b839f4","622":"2c138489","803":"16956dc0","870":"62df64dc","881":"f075f781","980":"bca79438"}[chunkId] + ".chunk.js";
};